import UpgradePopUpV2 from "./UpgradePopUpV2";

export default UpgradePopUpV2;
